import React from 'react';

export const AdminDashboardProjectsTab = ({ projects, onOpen3DProject, onOpenProject }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm" data-testid="admin-dashboard-projects-tab">
      <div className="p-6 border-b flex items-center justify-between">
        <h2 className="text-lg font-semibold text-gray-900" data-testid="admin-dashboard-projects-title">📁 Todos os Projetos</h2>
        <span className="text-gray-500" data-testid="admin-dashboard-projects-count">{projects.length} projetos</span>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full" data-testid="admin-dashboard-projects-table">
          <thead className="bg-gray-50">
            <tr>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Projeto</th>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Usuário</th>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Cômodos</th>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Views 3D</th>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Criado em</th>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Ações</th>
            </tr>
          </thead>

          <tbody className="divide-y">
            {projects.map((project) => (
              <tr key={project.id} className="hover:bg-gray-50" data-testid={`admin-dashboard-project-row-${project.id}`}>
                <td className="px-6 py-4">
                  <p className="font-medium text-gray-900" data-testid={`admin-dashboard-project-name-${project.id}`}>{project.name}</p>
                  <p className="text-sm text-gray-500 truncate max-w-xs" data-testid={`admin-dashboard-project-description-${project.id}`}>{project.description}</p>
                </td>
                <td className="px-6 py-4">
                  <p className="text-gray-900" data-testid={`admin-dashboard-project-user-name-${project.id}`}>{project.user_name || 'N/A'}</p>
                  <p className="text-sm text-gray-500" data-testid={`admin-dashboard-project-user-email-${project.id}`}>{project.user_email}</p>
                </td>
                <td className="px-6 py-4 text-gray-600" data-testid={`admin-dashboard-project-rooms-${project.id}`}>
                  {project.floor_plan?.rooms?.length || 0}
                </td>
                <td className="px-6 py-4">
                  <span className="inline-flex items-center px-2 py-1 bg-purple-100 text-purple-700 rounded-full text-sm" data-testid={`admin-dashboard-project-views-${project.id}`}>
                    👁️ {project.view_count_3d || 0}
                  </span>
                </td>
                <td className="px-6 py-4 text-gray-600 text-sm" data-testid={`admin-dashboard-project-created-at-${project.id}`}>
                  {new Date(project.created_at).toLocaleDateString('pt-BR')}
                </td>
                <td className="px-6 py-4">
                  <div className="flex gap-2">
                    <button
                      onClick={() => onOpen3DProject(project.id)}
                      className="px-3 py-1 bg-purple-100 text-purple-700 rounded text-sm hover:bg-purple-200"
                      data-testid={`admin-dashboard-project-open-3d-${project.id}`}
                    >
                      3D
                    </button>
                    <button
                      onClick={() => onOpenProject(project.id)}
                      className="px-3 py-1 bg-blue-100 text-blue-700 rounded text-sm hover:bg-blue-200"
                      data-testid={`admin-dashboard-project-open-${project.id}`}
                    >
                      Ver
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
